import { Modal } from 'carbon-components-react';
import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'effector-react';
import { useHistory } from 'react-router';
import { patchSetExternalOrganizationFX } from '../../store/user/effects';
import PortalModal from '../PortalModal';
import { RHFSelect } from '../rhf-fields/select/RHFSelect';
import { $userStore } from '../../store/user';
import { DropdownType } from '../../store/classifiers/interfaces';
import { USER_PROFILE } from '../../routes/constants';
import { $externalUserModalOpen, closeExternalUserModalEV } from '../../store/externalUserModal';
import { setAccountUuidEV } from '../../store/user/events';
import { setProfileTypeEV } from '../../store/main/events';
import { ProfileTypeEnum } from '../../store/main/interface';

export const ExternalUserModal = () => {
  const { t } = useTranslation();
  const isOpened = useStore($externalUserModalOpen);
  const [stateSelect, setStateSelect] = useState<DropdownType>();
  const user = useStore($userStore);
  const history = useHistory();

  useEffect(() => {
    setStateSelect(undefined);
  }, [isOpened]);

  const organizations = useMemo(
    () =>
      user?.accounts?.partner_organizations?.map((organization) => ({
        label: organization.name,
        value: organization.uuid,
      })) ?? [],
    [user?.accounts?.partner_organizations]
  );

  if (!isOpened) {
    return null;
  }

  const handleYes = () => {
    if (!stateSelect?.value) {
      return;
    }

    patchSetExternalOrganizationFX({ uuid: stateSelect.value }).then(() => {
      setAccountUuidEV(stateSelect.value);
      setProfileTypeEV(ProfileTypeEnum.PARTNER_ORGANIZATION);
      closeExternalUserModalEV();
      history.push(USER_PROFILE);
    });
  };

  return (
    <PortalModal>
      <Modal
        size="sm"
        modalHeading={t('EXTERNAL_MODAL_TITLE')}
        onRequestSubmit={handleYes}
        primaryButtonText={t('YES')}
        primaryButtonDisabled={!stateSelect}
        secondaryButtonText={t('NO')}
        onSecondarySubmit={() => closeExternalUserModalEV()}
        open={isOpened}
        onRequestClose={() => closeExternalUserModalEV()}
        className="web-epak__modal organization"
      >
        <RHFSelect
          id="external_user_select"
          field={{ value: stateSelect, onChange: (e: any) => setStateSelect(e) }}
          label={<span>{t('EXTERNAL_USER_SELECT')}</span>}
          options={organizations}
        />
      </Modal>
    </PortalModal>
  );
};
